import { notifyMutation } from "@/components/mm/FeedbackPopup";
import axios from "axios";
import { Capacitor } from "@capacitor/core";
import { SecureStorage } from "@aparajita/capacitor-secure-storage";

import { installOffline, nativeOffline, offline } from "./offlineNative";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "mm_token";
let tokenCache = null;

export async function initAuthToken() {
  try {
    tokenCache = Capacitor.isNativePlatform() ? await SecureStorage.get(TOKEN_KEY) : sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
  } catch { tokenCache = null; }
  if (nativeOffline) await offline.restore(tokenCache);
  return tokenCache;
}

export function getAuthToken() { return tokenCache; }

export async function setAuthToken(token, persistent = false, preservePending = false) {
  tokenCache = token || null;
  let cleanupError;
  if (!token && nativeOffline) {
    try { if (preservePending) await offline.lock(); else await offline.clear(); }
    catch (error) { cleanupError = error; }
  }
  if (Capacitor.isNativePlatform()) {
    if (token && persistent) await SecureStorage.set(TOKEN_KEY, token); else await SecureStorage.remove(TOKEN_KEY);
  } else if (token) {
    localStorage.removeItem(TOKEN_KEY); sessionStorage.removeItem(TOKEN_KEY);
    (persistent ? localStorage : sessionStorage).setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY); sessionStorage.removeItem(TOKEN_KEY);
  }
  if (cleanupError) throw cleanupError;
}

export const api = axios.create({ baseURL: `${BACKEND}/api`, timeout: 30000 });

api.interceptors.request.use((c) => {
  const t = tokenCache;
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  (r) => {
    if (!r.config?.offlineBypass && !r.config?.silentFeedback) notifyMutation(r.config?.method || 'GET', r.config?.url || '', r.statusText === 'Local; sync pending');
    return r;
  },
  (e) => {
    if (e.response?.status === 401 && !String(e.config?.url).startsWith("/auth/")) {
      setAuthToken(null, false, true).catch(() => {});
      window.dispatchEvent(new Event("mm-logout"));
    }
    return Promise.reject(e);
  }
);

installOffline(api);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}
